/**
 * Step navigation for the structured verification workflow.
 *
 * The workflow's step list is dynamic (a listing check inserts a
 * 'Listing findings' step, and the 'Compliance Check' step is Professional-tier
 * only), so nothing may key off a fixed index. These pure helpers move between
 * VISIBLE steps by name.
 *
 * `verifierTier` may be undefined/null while the verifier profile is still
 * loading — an unknown tier is treated as "show everything" so we never skip a
 * step the verifier is entitled to.
 */

export const isStepVisible = (name, verifierTier) =>
  name !== 'Compliance Check' || !verifierTier || verifierTier === 'professional';

export const nextVisibleStep = (steps, verifierTier, from) => {
  let i = from + 1;
  while (i < steps.length - 1 && !isStepVisible(steps[i], verifierTier)) i++;
  return Math.max(0, Math.min(i, steps.length - 1));
};

export const prevVisibleStep = (steps, verifierTier, from) => {
  let i = from - 1;
  while (i > 0 && !isStepVisible(steps[i], verifierTier)) i--;
  return Math.max(0, Math.min(i, steps.length - 1));
};
